import React from 'react';
import investing from '../../images/investing.png';
import account from '../../images/account.png';
import lowerCost from '../../images/lower-cost.png';
import signature from '../../images/signature.png';
import xiaoMi from '../../images/xiao-mi.png';
import brokerage from '../../images/brokerage.png';

import './style.scss';

const Market: React.FC = () => {
    return (
        <>
            <div className="brand-market">
                <h3>Global Markets In Your Pocket</h3>
                <div className="content">
                    <div className="item">
                        <img src={investing} alt="investing" />
                        <p className="title">Investing At Your Fingertips</p>
                        <p>Seize opportunities on the go with our mobile-driven platform, anytime, anywhere.</p>
                    </div>
                    <div className="item">
                        <img src={account} alt="account" />
                        <p className="title">One Account, Invest Globally</p>
                        <p>One account to tap into global investment options.</p>
                    </div>
                    <div className="item">
                        <img src={lowerCost} alt="lower cost" />
                        <p className="title">Lower Cost, Better Value</p>
                        <p>Enjoy competitive commission at Tiger and add value to your investing journey.</p>
                    </div>
                </div>
            </div>
            <div className="brand-market">
                <h3>Our Reputable Strategic Investors</h3>
                <div className="content invest">
                    <div className="item">
                        <img src={brokerage} alt="brokerage" className="brokerage" />
                        <p className="desc brokerage-desc">Barron’s Top Online Brokerage Company </p>
                    </div>
                    <div className="item line">
                        <img src={xiaoMi} alt="xiao mi" className="xiao-mi" />
                        <p className="desc xiao-mi-desc">Well Known Tech Company Xiaomi Corp</p>
                    </div>
                    <div className="item">
                        <img src={signature} alt="signature" className="signature" />
                        <p className="desc signature-desc">Wall Street Investment Guru Jim Rogers</p>
                    </div>
                </div>
            </div>
        </>
    );
};

export default Market;
